unit InvoiceListPage;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  BaseList,
  WEBLib.ExtCtrls,
  WEBLib.Actions,
  Data.DB,
  WEBLib.DB,
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.Grids,
  WEBLib.DBCtrls,
  Vcl.Controls,
  WEBLib.Lists,
  smx.webcore.types;

type
  TInvoiceListForm = class(TBaseListForm)
    MainDatasetId: TIntegerField;
    MainDatasetDateAdded: TDateTimeField;
    MainDatasetAddedBy: TIntegerField;
    MainDatasetLastUpdatedBy: TIntegerField;
    MainDatasetLastUpdated: TDateTimeField;
    MainDatasetDueDate: TDateField;
    MainDatasetGrossAmount: TFloatField;
    MainDatasetInvoiceDate: TDateField;
    MainDatasetInvoiceRef: TStringField;
    MainDatasetInvoiceType: TStringField;
    MainDatasetNetAmount: TFloatField;
    MainDatasetParentId: TIntegerField;
    MainDatasetTaxRate: TFloatField;
    MainDatasetTax: TFloatField;
    MainDatasetTotalAmount: TFloatField;
    MainDatasetPaidInFull: TBooleanField;
    MainDatasetHandbookSent: TBooleanField;
    chkExcludePaidInvoices: TCheckBox;
    procedure WebFormShow(Sender: TObject);
    procedure DataTableGetCellData(Sender: TObject; ACol, ARow: Integer;
      AField: TField; var AValue: string);
    procedure OnClick_ExcludePaidInvoices(Sender: TObject);
    procedure cbPageSizeChange(Sender: TObject);
    procedure DataTableGetCellChildren(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
  private
    { Private declarations }

    [async]
    procedure ShowRemittances(const ARecordId: string); async;

    [async]
    procedure ResendInvoice(const ARecordId: string); async;

    [async]
    procedure ResendHandbook(const ARecordId: string); async;

  protected
    procedure PrepareForm; override;

    procedure LoadData; override;

    [async]
    procedure EditRecord(const ARecordId: string); async; override;

    function InitSortCol: Integer; override;
    function InitSortDirection: TSortDirection; override;

    procedure AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement); override;

  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  InvoiceListForm: TInvoiceListForm;

implementation

{$R *.dfm}

uses
  InvoiceEditPage,
  MainDataModule,
  WEBLib.WebCtrls,
  SMX.Web.Layout.Utils,
  InvoiceRemittanceViewerPage,
  XData.Web.Client;

procedure TInvoiceListForm.PrepareForm;
begin
  FIdField := 'Id';

  MainDataset.Connection := MainData.DataConnection;

end;

procedure TInvoiceListForm.WebFormShow(Sender: TObject);
begin
  inherited;

  cbPageSizeChange(cbPageSize);

end;

procedure TInvoiceListForm.LoadData;
begin
  if chkExcludePaidInvoices.Checked then
    MainDataSet.QueryString := '$filter= PaidInFull ne true'
  else
    MainDataSet.QueryString := '';

  MainDataset.Close;
  MainDataset.Load;

end;

procedure TInvoiceListForm.OnClick_ExcludePaidInvoices(Sender: TObject);
begin
  inherited;

  LoadData;

end;

procedure TInvoiceListForm.cbPageSizeChange(Sender: TObject);
begin
  inherited;

  LoadData;

end;

procedure TInvoiceListForm.DataTableGetCellChildren(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
begin
  inherited;

  if Sender is TDBTableControl then
  begin
    // hide first column
    if ACol = 0 then
    begin
      AElement.Element.style.setProperty('display', 'none');

    end;

  end;

end;

procedure TInvoiceListForm.DataTableGetCellData(Sender: TObject; ACol,
  ARow: Integer; AField: TField; var AValue: string);
begin
  inherited;

  if Sender is TDBTableControl then
  begin
    if TDBTableControl(Sender).Columns[ACol].DataField = 'GrossAmount' then
    begin
      if Assigned(AField) then
      begin
        // format data if available, otherwise clear field
        if AField.IsNull then
          AValue := ''
        else
          AValue := FormatFloat('£#,##0.00', AField.AsFloat);

      end
      else
      begin
        // don't clear header row
        if ARow <> 0 then
          AValue := '';

      end;

    end;

  end;

end;

procedure TInvoiceListForm.EditRecord(const ARecordId: string);
var
  AForm: TInvoiceEditForm;

begin
  //this isn't really Async until the next version of XData
  Await(MainData.OpenSchoolLookUp);

  // child data set
  if ARecordId = ''  then
  begin
    MainDataset.Append;
    MainData.OpenInvoiceDetail(0);

  end
  else
  begin
    MainDataset.Locate('Id', ARecordId.ToInteger, []);
    Await(MainData.OpenInvoiceDetail(ARecordId.ToInteger));

  end;

  AForm := TInvoiceEditForm.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    AForm.IdField := FIdField;

    Await(TInvoiceEditForm, AForm.Load());
    Await(AForm.InitForm);

    AForm.Dataset := MainDataset;
    AForm.ChildDataSource.DataSet := MainData.InvoiceDetailDataSet;

    Await(TModalResult, AForm.Execute);

  finally
    AForm.Free;
    AForm := nil;

  end;

end;

function TInvoiceListForm.InitSortCol: Integer;
begin
  // default sorting by invoice reference
  Result := 2;

end;

function TInvoiceListForm.InitSortDirection: TSortDirection;
begin
  // default to ascending sort order
  Result := sdAsc;

end;

procedure TInvoiceListForm.AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);

  procedure ShowRemittancesClick(Sender: TObject);
  begin
    ShowRemittances(ARecordId);

  end;

  procedure ResendInvoiceClick(Sender: TObject);
  begin
    ResendInvoice(ARecordId);

  end;

  procedure ResendHandbookClick(Sender: TObject);
  begin
    ResendHandbook(ARecordId);

  end;

var
  Span: THTMLSpan;

begin
  inherited;

  if (RecordViewOption in [voEdit, voCreateAndEdit]) then
  begin
    Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-money-bill-transfer', 'View Payments');
    Span.OnClick := @ShowRemittancesClick;

    Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-file-invoice', 'Resend Invoice');
    Span.OnClick := @ResendInvoiceClick;
    if MainDataset.FieldByName('PaidInFull').AsBoolean then
      Span.Hide;

    Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-file', 'Resend Handbook');
    Span.OnClick := @ResendHandbookClick;
    if not MainDataset.FieldByName('HandbookSent').AsBoolean then
      Span.Hide;

  end
  else if RecordViewOption = voReadOnly then
  begin
    Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-money-bill-transfer', 'Remittances');
    Span.OnClick := @ShowRemittancesClick;

  end;

end;

procedure TInvoiceListForm.ShowRemittances(const ARecordId: string);
var
  AForm: TInvoiceRemittanceViewerForm;

begin
  // there should always be an id
  if ARecordId = ''  then
    raise Exception.Create('Invalid invoice id selected');

  MainDataset.Locate('Id', ARecordId.ToInteger, []);
  Await(MainData.LoadRemittanceLookup(StrToInt(ARecordId)));

  AForm := TInvoiceRemittanceViewerForm.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    AForm.IdField := FIdField;

    Await(TInvoiceRemittanceViewerForm, AForm.Load());
    Await(AForm.InitForm);

    AForm.Dataset := MainDataset;
    AForm.RemittanceDataSource.DataSet := MainData.RemittanceLookup;

    Await(TModalResult, AForm.Execute);

  finally
    AForm.Free;
    AForm := nil;

  end;

end;

procedure TInvoiceListForm.ResendInvoice(const ARecordId: string);
var
  iIdx: Integer;
  jsaResponseList: JS.TJSArray;
  oClientResponse: TXDataClientResponse;
  slMessages: TStringList;
  bSuccess: Boolean;
  jsoServerResponse: JS.TJSObject;

begin
  // resend the selected invoice
  oClientResponse := Await(
    TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync(
      'ISchoolService.ResendInvoice',
      [ ARecordId ]
    )
  );

  // generate list of errors to display to the user
  slMessages := TStringList.Create;
  slMessages.Delimiter := #13;
  slMessages.StrictDelimiter := True;
  slMessages.Add('');
  slMessages.Add('');

  jsaResponseList := JS.toArray(oClientResponse.ResultAsObject['ServerResponses']);

  bSuccess := True;
  for iIdx := 0 to jsaResponseList.Length - 1 do
  begin
    jsoServerResponse := JS.toObject(jsaResponseList[iIdx]);

    bSuccess := bSuccess and JS.toBoolean(jsoServerResponse['Success']);
    slMessages.Add(JS.toString(jsoServerResponse['Status']));

  end;

  if bSuccess then
    slMessages.Insert(0, 'SUCCESS')
  else
    slMessages.Insert(0, 'ERROR');

  ShowMessage(slMessages.DelimitedText);

  slMessages.Free;

end;

procedure TInvoiceListForm.ResendHandbook(const ARecordId: string);
var
  iIdx: Integer;
  jsaResponseList: JS.TJSArray;
  oClientResponse: TXDataClientResponse;
  slMessages: TStringList;
  bSuccess: Boolean;
  jsoServerResponse: JS.TJSObject;

begin
  // resend the selected invoice
  oClientResponse := Await(
    TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync(
      'ISchoolService.SendHandbook',
      [ ARecordId ]
    )
  );

  // generate list of errors to display to the user
  slMessages := TStringList.Create;
  slMessages.Delimiter := #13;
  slMessages.StrictDelimiter := True;
  slMessages.Add('');
  slMessages.Add('');

  jsaResponseList := JS.toArray(oClientResponse.ResultAsObject['ServerResponses']);

  bSuccess := True;
  for iIdx := 0 to jsaResponseList.Length - 1 do
  begin
    jsoServerResponse := JS.toObject(jsaResponseList[iIdx]);

    bSuccess := bSuccess and JS.toBoolean(jsoServerResponse['Success']);
    slMessages.Add(JS.toString(jsoServerResponse['Status']));

  end;

  if bSuccess then
    slMessages.Insert(0, 'SUCCESS')
  else
    slMessages.Insert(0, 'ERROR');

  ShowMessage(slMessages.DelimitedText);

  slMessages.Free;

end;


procedure TInvoiceListForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  chkExcludePaidInvoices := TCheckBox.Create('exclude-paid-in-full');
  MainDatasetId := TIntegerField.Create(Self);
  MainDatasetDateAdded := TDateTimeField.Create(Self);
  MainDatasetAddedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdatedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdated := TDateTimeField.Create(Self);
  MainDatasetDueDate := TDateField.Create(Self);
  MainDatasetGrossAmount := TFloatField.Create(Self);
  MainDatasetInvoiceDate := TDateField.Create(Self);
  MainDatasetInvoiceRef := TStringField.Create(Self);
  MainDatasetInvoiceType := TStringField.Create(Self);
  MainDatasetNetAmount := TFloatField.Create(Self);
  MainDatasetParentId := TIntegerField.Create(Self);
  MainDatasetTaxRate := TFloatField.Create(Self);
  MainDatasetTax := TFloatField.Create(Self);
  MainDatasetTotalAmount := TFloatField.Create(Self);
  MainDatasetPaidInFull := TBooleanField.Create(Self);
  MainDatasetHandbookSent := TBooleanField.Create(Self);

  DataTable.BeforeLoadDFMValues;
  chkExcludePaidInvoices.BeforeLoadDFMValues;
  MainDataset.BeforeLoadDFMValues;
  MainDatasetId.BeforeLoadDFMValues;
  MainDatasetDateAdded.BeforeLoadDFMValues;
  MainDatasetAddedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdatedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdated.BeforeLoadDFMValues;
  MainDatasetDueDate.BeforeLoadDFMValues;
  MainDatasetGrossAmount.BeforeLoadDFMValues;
  MainDatasetInvoiceDate.BeforeLoadDFMValues;
  MainDatasetInvoiceRef.BeforeLoadDFMValues;
  MainDatasetInvoiceType.BeforeLoadDFMValues;
  MainDatasetNetAmount.BeforeLoadDFMValues;
  MainDatasetParentId.BeforeLoadDFMValues;
  MainDatasetTaxRate.BeforeLoadDFMValues;
  MainDatasetTax.BeforeLoadDFMValues;
  MainDatasetTotalAmount.BeforeLoadDFMValues;
  MainDatasetPaidInFull.BeforeLoadDFMValues;
  MainDatasetHandbookSent.BeforeLoadDFMValues;
  try
    SetEvent(Self, 'OnShow', 'WebFormShow');
    SetEvent(DataTable, Self, 'OnGetCellData', 'DataTableGetCellData');
    DataTable.Columns.Clear;
    with DataTable.Columns.Add do
    begin
      DataField := 'Id';
      Title := 'Id';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'InvoiceDate';
      Title := 'Date';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'InvoiceRef';
      Title := 'Reference';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'GrossAmount';
      Title := 'Amount';
    end;
    with DataTable.Columns.Add do
    begin
      Title := 'Actions';
      Width := 475;
    end;
    chkExcludePaidInvoices.SetParentComponent(Self);
    chkExcludePaidInvoices.Name := 'chkExcludePaidInvoices';
    chkExcludePaidInvoices.Left := 120;
    chkExcludePaidInvoices.Top := 72;
    chkExcludePaidInvoices.Width := 113;
    chkExcludePaidInvoices.Height := 22;
    chkExcludePaidInvoices.Caption := 'Exclude Paid Invoices';
    chkExcludePaidInvoices.Checked := True;
    chkExcludePaidInvoices.ChildOrder := 9;
    chkExcludePaidInvoices.ElementClassName := 'custom-control custom-checkbox';
    chkExcludePaidInvoices.ElementButtonClassName := 'custom-control-input';
    chkExcludePaidInvoices.ElementLabelClassName := 'custom-control-label';
    chkExcludePaidInvoices.ElementFont := efCSS;
    chkExcludePaidInvoices.ElementPosition := epIgnore;
    chkExcludePaidInvoices.HeightStyle := ssAuto;
    chkExcludePaidInvoices.HeightPercent := 100.000000000000000000;
    chkExcludePaidInvoices.State := cbChecked;
    chkExcludePaidInvoices.WidthStyle := ssAuto;
    chkExcludePaidInvoices.WidthPercent := 100.000000000000000000;
    SetEvent(chkExcludePaidInvoices, Self, 'OnClick', 'OnClick_ExcludePaidInvoices');
    MainDataset.EntitySetName := 'SchoolInvoice';
    MainDatasetId.SetParentComponent(MainDataset);
    MainDatasetId.Name := 'MainDatasetId';
    MainDatasetId.FieldName := 'Id';
    MainDatasetDateAdded.SetParentComponent(MainDataset);
    MainDatasetDateAdded.Name := 'MainDatasetDateAdded';
    MainDatasetDateAdded.FieldName := 'DateAdded';
    MainDatasetAddedBy.SetParentComponent(MainDataset);
    MainDatasetAddedBy.Name := 'MainDatasetAddedBy';
    MainDatasetAddedBy.FieldName := 'AddedBy';
    MainDatasetLastUpdatedBy.SetParentComponent(MainDataset);
    MainDatasetLastUpdatedBy.Name := 'MainDatasetLastUpdatedBy';
    MainDatasetLastUpdatedBy.FieldName := 'LastUpdatedBy';
    MainDatasetLastUpdated.SetParentComponent(MainDataset);
    MainDatasetLastUpdated.Name := 'MainDatasetLastUpdated';
    MainDatasetLastUpdated.FieldName := 'LastUpdated';
    MainDatasetDueDate.SetParentComponent(MainDataset);
    MainDatasetDueDate.Name := 'MainDatasetDueDate';
    MainDatasetDueDate.FieldName := 'DueDate';
    MainDatasetGrossAmount.SetParentComponent(MainDataset);
    MainDatasetGrossAmount.Name := 'MainDatasetGrossAmount';
    MainDatasetGrossAmount.FieldName := 'GrossAmount';
    MainDatasetInvoiceDate.SetParentComponent(MainDataset);
    MainDatasetInvoiceDate.Name := 'MainDatasetInvoiceDate';
    MainDatasetInvoiceDate.FieldName := 'InvoiceDate';
    MainDatasetInvoiceRef.SetParentComponent(MainDataset);
    MainDatasetInvoiceRef.Name := 'MainDatasetInvoiceRef';
    MainDatasetInvoiceRef.FieldName := 'InvoiceRef';
    MainDatasetInvoiceRef.Size := 50;
    MainDatasetInvoiceType.SetParentComponent(MainDataset);
    MainDatasetInvoiceType.Name := 'MainDatasetInvoiceType';
    MainDatasetInvoiceType.FieldName := 'InvoiceType';
    MainDatasetInvoiceType.Size := 10;
    MainDatasetNetAmount.SetParentComponent(MainDataset);
    MainDatasetNetAmount.Name := 'MainDatasetNetAmount';
    MainDatasetNetAmount.FieldName := 'NetAmount';
    MainDatasetParentId.SetParentComponent(MainDataset);
    MainDatasetParentId.Name := 'MainDatasetParentId';
    MainDatasetParentId.FieldName := 'ParentId';
    MainDatasetTaxRate.SetParentComponent(MainDataset);
    MainDatasetTaxRate.Name := 'MainDatasetTaxRate';
    MainDatasetTaxRate.FieldName := 'TaxRate';
    MainDatasetTax.SetParentComponent(MainDataset);
    MainDatasetTax.Name := 'MainDatasetTax';
    MainDatasetTax.FieldName := 'Tax';
    MainDatasetTotalAmount.SetParentComponent(MainDataset);
    MainDatasetTotalAmount.Name := 'MainDatasetTotalAmount';
    MainDatasetTotalAmount.FieldName := 'TotalAmount';
    MainDatasetPaidInFull.SetParentComponent(MainDataset);
    MainDatasetPaidInFull.Name := 'MainDatasetPaidInFull';
    MainDatasetPaidInFull.FieldName := 'PaidInFull';
    MainDatasetHandbookSent.SetParentComponent(MainDataset);
    MainDatasetHandbookSent.Name := 'MainDatasetHandbookSent';
    MainDatasetHandbookSent.FieldName := 'HandbookSent';
  finally
    DataTable.AfterLoadDFMValues;
    chkExcludePaidInvoices.AfterLoadDFMValues;
    MainDataset.AfterLoadDFMValues;
    MainDatasetId.AfterLoadDFMValues;
    MainDatasetDateAdded.AfterLoadDFMValues;
    MainDatasetAddedBy.AfterLoadDFMValues;
    MainDatasetLastUpdatedBy.AfterLoadDFMValues;
    MainDatasetLastUpdated.AfterLoadDFMValues;
    MainDatasetDueDate.AfterLoadDFMValues;
    MainDatasetGrossAmount.AfterLoadDFMValues;
    MainDatasetInvoiceDate.AfterLoadDFMValues;
    MainDatasetInvoiceRef.AfterLoadDFMValues;
    MainDatasetInvoiceType.AfterLoadDFMValues;
    MainDatasetNetAmount.AfterLoadDFMValues;
    MainDatasetParentId.AfterLoadDFMValues;
    MainDatasetTaxRate.AfterLoadDFMValues;
    MainDatasetTax.AfterLoadDFMValues;
    MainDatasetTotalAmount.AfterLoadDFMValues;
    MainDatasetPaidInFull.AfterLoadDFMValues;
    MainDatasetHandbookSent.AfterLoadDFMValues;
  end;
end;

end.